import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

const About: FC = () => {

    return (
        <div className="m-3">
            <h5>Employments</h5>
        </div>
    )
};
export default observer(About);